export const LAST_UPDATED_DATE_FORMAT = 'dd-MMM-yyyy';
